exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".middle-buttons__play__3JrgR,.middle-buttons__purchase__40Ju-{overflow:hidden;height:auto;padding:0;border-radius:0;border:none;font-size:14px;color:#fff}.middle-buttons__icon__3ryEt{width:30px;height:30px;border-width:2px;border-color:#fff;margin-right:7px}.middle-buttons__play-icon__Oo-HK:before{transform:scale(.8);left:2px;position:relative}.middle-buttons__text__3QiaB{width:100%;border-bottom:1px solid #fff;line-height:normal;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.middle-buttons__purchase__40Ju- .middle-buttons__text__3QiaB{display:inline-block}", ""]);

// exports
exports.locals = {
	"play": "middle-buttons__play__3JrgR",
	"purchase": "middle-buttons__purchase__40Ju-",
	"icon": "middle-buttons__icon__3ryEt",
	"play-icon": "middle-buttons__play-icon__Oo-HK",
	"playIcon": "middle-buttons__play-icon__Oo-HK",
	"text": "middle-buttons__text__3QiaB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.styl
// module id = 2922
// module chunks = 1